import { ComponentType } from 'react';

import { ChartTooltipElementProps, SxProps } from '@cast/design-system';

import { ChartConfig, ChartType } from 'types/charts';

import { TimeSeries } from '../../../../types/metrics';

export const ResourceUtilizationChartType = {
  AREA: ChartType.AREA,
  BAR: ChartType.BAR,
};
export type ResourceUtilizationChartType =
  (typeof ResourceUtilizationChartType)[keyof typeof ResourceUtilizationChartType];

export enum ResourceUtilizationMetricType {
  NODE_COUNT = 'node_count',
  PROVISIONED = 'provisioned',
  ALLOCATABLE = 'allocatable',
  REQUESTED = 'requested',
  ACTUAL_USAGE = 'used',
  GPU_USAGE = 'gpuUsed',
  GPU_MEMORY_USAGE = 'gpuMemoryUsed',
}

export type ResourceUtilizationYAxisProps = {
  padding?: { top?: number };
  tickCount?: number;
  unitFormatter?: (
    formattedValue: string,
    context: { value: any; index: number }
  ) => string;
};

export type ResourceUtilizationChartProps = {
  data: TimeSeries<any>;
  chartConfig: ChartConfig[];
  tooltipHeader?: ComponentType<ChartTooltipElementProps<any>>;
  tooltipFooter?: ComponentType<ChartTooltipElementProps<any>>;
  isAnimationActive?: boolean;
  yAxisProps?: ResourceUtilizationYAxisProps;
  sx?: SxProps;
  barThreshold?: number;
};

export type ResourceUtilizationChartData = {
  provisioned: number | null;
  requested: number | null;
  used: number | null;
};

export type CpuUtilizationChartData = ResourceUtilizationChartData;
export type MemoryUtilizationChartData = ResourceUtilizationChartData;
export type GpuUtilizationChartData = {
  gpuRequested: number | null;
  gpuUsed: number | null;
  gpuMemoryUsed: number | null;
};
export type StorageUtilizationChartData = {
  provisioned: number | null;
  requested: number | null;
};

export type ResourceChartData<T extends object> = {
  datapoints: TimeSeries<T>;
  hasNoData: boolean;
};

export type ResourceChartDatapoints = {
  cpu: ResourceChartData<CpuUtilizationChartData>;
  memory: ResourceChartData<MemoryUtilizationChartData>;
  gpu: ResourceChartData<GpuUtilizationChartData>;
  storage: ResourceChartData<StorageUtilizationChartData>;
};
